/** Does never throw -- returns `null` in case of an error. */
function getItem(key: string): null | string;
function getItem<T>(key: string, deserialize: (s: string) => T): null | T;
function getItem<T>(key: string, deserialize?: (s: string) => T): null | string | T {
  try {
    const s = localStorage.getItem(key);
    return s === null ? null : deserialize ? deserialize(s) : s;
  } catch {
    return null;
  }
}

/** Does never throw. */
function setItem(key: string, value: string): void;
function setItem<T>(key: string, value: T, serialize: (item: T) => string): void;
function setItem<T>(key: string, value: T, serialize?: (item: T) => string): void {
  try {
    localStorage.setItem(key, serialize ? serialize(value) : (value as string));
  } catch {
    // Ignored.
  }
}

function removeItem(key: string): void {
  try {
    localStorage.removeItem(key);
  } catch {
    // Ignored.
  }
}

export const safeLocalStorage = { getItem, setItem, removeItem };
